// src/stripe/createCheckoutSession.js
import { collection, addDoc, onSnapshot } from "firebase/firestore";
import { firestore } from "../firebase";


export async function createCheckoutSession(uid, productId, paymentMethod = "card") {

  function getLineItemsByProduct(productId) {
    if (productId === "plano_growth_a") {
      return [
        { price: "price_1QPpCxEgi4LYcJWIFKIv0Jgl", quantity: 1 },
        { price: "price_1RqHnuEgi4LYcJWIrh0q00FK" }
      ];
    }

    if (productId === "plano_growth_b") {
      return [
        { price: "price_1QPpCxEgi4LYcJWIFKIv0Jgl", quantity: 1 },
        { price: "price_1SuwfxEgi4LYcJWIdTlAc2rg" }
      ];
    }

    if (productId === "plano_growth_c") {
      return [
        { price: "price_1QPpCxEgi4LYcJWIFKIv0Jgl", quantity: 1 },
        { price: "price_1T6yqvEgi4LYcJWIuTQck19X" }
      ];
    }

    if (productId === "plano_growth_d") {
      return [
        { price: "price_1QPpCxEgi4LYcJWIFKIv0Jgl", quantity: 1 },
        { price: "price_1T6yrwEgi4LYcJWISy9sDVlc" }
      ];
    }

    if (productId === "plano_growth_e") {
      return [
        { price: "price_1QPpCxEgi4LYcJWIFKIv0Jgl", quantity: 1 },
        { price: "price_1T6yvOEgi4LYcJWIXX21mmIf" }
      ];
    }
  
    if (productId === "plano_premium_a") {
      return [
        { price: "price_1PpWnPEgi4LYcJWI2a3rDzvQ", quantity: 1 },
        { price: "price_1RqHnuEgi4LYcJWIrh0q00FK" }
      ];
    }

    if (productId === "plano_premium_b") {
      return [
        { price: "price_1PpWnPEgi4LYcJWI2a3rDzvQ", quantity: 1 },
        { price: "price_1SuwfxEgi4LYcJWIdTlAc2rg" }
      ];
    }

    if (productId === "plano_premium_c") {
      return [
        { price: "price_1PpWnPEgi4LYcJWI2a3rDzvQ", quantity: 1 },
        { price: "price_1T6yqvEgi4LYcJWIuTQck19X" }
      ];
    }

    if (productId === "plano_premium_d") {
      return [
        { price: "price_1PpWnPEgi4LYcJWI2a3rDzvQ", quantity: 1 },
        { price: "price_1T6yrwEgi4LYcJWISy9sDVlc" }
      ];
    }

    if (productId === "plano_premium_e") {
      return [
        { price: "price_1PpWnPEgi4LYcJWI2a3rDzvQ", quantity: 1 },
        { price: "price_1T6yvOEgi4LYcJWIXX21mmIf" }
      ];
    }
  
    throw new Error("ProductId inválido");
  
  }

  const lineItems = getLineItemsByProduct(productId);

  const sessionData = {
    mode: "subscription",
    allow_promotion_codes: true,
    line_items: lineItems,
    payment_method_types: paymentMethod === "boleto" ? ["boleto"] : ["card"],
    success_url: window.location.origin + "/sucesso",
    cancel_url: window.location.origin + "/cancelado",
  };

  if (paymentMethod === "boleto") {
    sessionData.tax_id_collection = { enabled: true };
    sessionData.billing_address_collection = "required";
  }

  const checkoutRef = await addDoc(
    collection(firestore, `users/${uid}/checkout_sessions`),
    sessionData
  );

  // Escutar URL do checkout gerada pela extensão
  onSnapshot(checkoutRef, (snap) => {
    const data = snap.data()

    if (data?.url) {
      window.location.assign(data.url)
    }

    if (data?.error) {
      alert(data.error.message)
    }
  })
}